<div class="panel panel-data">
  <div class="panel-header">
    <h3 class="panel-title">Intraday Rates</h3>
    <div class="panel-actions">
      <div class="panel-action">
        <label class="custom-control custom-checkbox">
          <input class="custom-control-input" type="checkbox" [(ngModel)]="showRecessions" (ngModelChange)="updateShowRecessesions($event)" />
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">Show Recessions</span>
        </label>
      </div>
      <div class="panel-action">
        <a (click)="goToFundChartTab()" href="javascript:void(0)" class="btn btn-text">View Full Chart</a>
      </div>
    </div>
  </div>
  <div class="panel-content">
    <div class="row">
      <div class="col-lg-7">
          <ycn-simple-fund-chart
            [calcs]="chartCalcs"
            [showRecessions]="showRecessions"
            [securityIds]="indicesList"
          ></ycn-simple-fund-chart>
      </div>
      <div class="col-lg-5">
        <table class="table">
          <thead>
            <tr>
              <td class="text-thin">Type</td>
              <td class="text-right text-thin">Level</td>
              <td class="text-right text-thin text-nowrap">1 DAY CHG</td>
              <td class="text-right text-thin text-nowrap">1 DAY % CHG</td>
            </tr>
          </thead>
          <tbody>
              @for (index of indices; let i = $index; track index.name) {
                <tr>
                    <td><a class="chart-legend-item-title" [class]="'bullet-'+(i+1)" [href]="index.url">
                      {{ index.name }}
                    </a></td>
                    <td class="text-right">{{ index.level ? index.level : '--' }}</td>
                    <td class="text-right">
                      @if (index.change !== null){
                        <strong [class]="index.change[0] == '+' ? 'text-green': 'text-red'">{{ index.change }}</strong>
                      } @else {
                        --
                      }
                    </td>
                    <td class="text-right">
                      @if (index.change_percent !== null){
                        <strong [class]="index.change_percent[0] == '+' ? 'text-green': 'text-red'">{{ index.change_percent }}</strong>
                      } @else {
                        --
                      }
                </tr>
              }
          </tbody>
        </table>
        <div class="panel-date">As of {{ latestDate }} EST</div>
      </div>
    </div>
  </div>
</div>
